import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';


class Acciones extends Component {
    constructor(props) {
        super(props);
    }

    eliminar = (id) => {
        return () => {
            Swal.fire({
                title: '¿Inactivar?',
                text: '¿Desea inactivar el usuario?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '¡Sí, inactivar!',
                cancelButtonText: 'No, cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.props.eliminar(id);
                }
            });
        }
    };


    activate = (id) => {
        return () => {
            Swal.fire({
                title: '¿Activar?',
                text: '¿Desea activar el usuario?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: '¡Sí, activar!',
                cancelButtonText: 'No, cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.props.activar(id);
                }
            });
        }
    };

    render() {
        const { id, ver, editar, eliminar, combo, tipo_pro } = this.props;

        return (
            <div className="d-flex justify-content-center">
                {(ver !== undefined) && (
                    <Link style={{color: "white"}} to={`${ver}/${id}/`} className="px-2" ><i className="material-icons">remove_red_eye</i></Link>
                )}
                {(editar !== undefined) && (
                    <Link style={{color: "white"}} to={`${editar}/${id}/editar`} ><i className="material-icons">edit</i></Link>
                )}
                {(eliminar !== undefined) && (
                    <a className="px-2" style={{cursor: "pointer", color: "red"}} onClick={this.eliminar(id)}><i className="material-icons">cancel</i></a>
                )}
                {(combo !== undefined && tipo_pro === 'C') && (
                    <Link style={{color: "white"}} to={`${editar}/${id}/combo`} ><i className="material-icons">widgets</i></Link>
                )}
            </div>
        );
    }
}
Acciones.propTypes = {
};

export function standardActions(acciones) {
    return (cell, row) => {
        return ( <Acciones id={cell} tipo_pro={row.tipo} {...acciones}/> )
    };
}
